import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import useResponsive from "../../hooks/useResponsive";
import { UserDataPropsType } from "../../interface/users";
import { useTheme } from "@mui/material/styles";
import { formatDateFromString } from "../../utils/url-id";
import AvatarImage from "../UIElements/avatar-image";
const headerSty = {
  fontFamily: "Lexend",
  letterSpacing: "0.01em",
  fontWeight: 400,
};
const contentSty = {
  fontFamily: "Lexend",
  letterSpacing: "0.01em",
  fontWeight: 400,
};

const ProfileTop = ({ user_info }: { user_info: UserDataPropsType }) => {
  const isSmall = useResponsive("down", "sm", "xl");
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");
  
  return (
    <>
      <Box sx={{ display: "flex", gap: 3, alignItems: " center" }}>
        <AvatarImage
          width={120}
          height={120}
          firstName={user_info?.first_name || user_info?.name || "M"}
          lastName={user_info?.last_name || user_info?.name || "M"}
        />
        <Stack>
          <Typography
            variant="h3"
            sx={{ fontWeight: 600, fontFamily: "Outfit", margin: 0 }}
            color={"neutral"}
          >
            {user_info?.name}
            {user_info?.first_name} {user_info?.middle_name}{" "}
            {user_info?.last_name}{" "}
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontFamily: "Outfit", color: "#2C393F", margin: 0 }}
          >
            {user_info.email}
          </Typography>
        </Stack>
      </Box>
      <Box
        sx={{
          backgroundColor: "#F7F8F9",
          borderRadius: "4",
          paddingLeft: 3,
          paddingY: "1.3rem",
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          minHeight: 70,
          my: 4,
        }}
      >
        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          sx={{
            paddingY: 1,
            marginX: isMedium ? 3 : 4,
            marginY: isMedium ? 2 : 0,
          }}
        >
          <Typography
            variant="caption"
            sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
          >
            Gender
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ ...contentSty, color: theme.palette.neutral.main }}
          >
            {user_info?.gender ?? "-"}
          </Typography>
        </Stack>
        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          sx={{
            paddingY: 1,
            marginX: isMedium ? 3 : 4,
            marginY: isMedium ? 2 : 0,
          }}
        >
          <Typography
            variant="caption"
            sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
          >
            Phone Number
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ ...contentSty, color: theme.palette.neutral.main }}
          >
            {user_info?.phone_number ?? "-"}
          </Typography>
        </Stack>
        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          sx={{
            paddingY: 1,
            marginX: isMedium ? 3 : 4,
            marginY: isMedium ? 2 : 0,
          }}
        >
          <Typography
            variant="caption"
            sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
          >
            IsVerified
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ ...contentSty, color: theme.palette.neutral.main }}
          >
            {`${user_info?.isVerified}`}
          </Typography>
        </Stack>
        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          sx={{
            paddingY: 1,
            marginX: isMedium ? 3 : 4,
            marginY: isMedium ? 2 : 0,
          }}
        >
          <Typography
            variant="caption"
            sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
          >
            Joined On
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ ...contentSty, color: theme.palette.neutral.main }}
          >
            {formatDateFromString(user_info?.created_at)}
          </Typography>
        </Stack>
        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          sx={{
            paddingY: 1,
            marginX: isMedium ? 3 : 4,
            marginY: isMedium ? 2 : 0,
          }}
        >
          <Typography
            variant="caption"
            sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
          >
            Role
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ ...contentSty, color: theme.palette.neutral.main }}
          >
            {`${user_info?.role ?? "-"}`}
          </Typography>
        </Stack>
      </Box>
    </>
  );
};

export default ProfileTop;
